import request from "@/utils/request";

function payDeviceAnnualFee(params) {
  return request.get(`/device/agent/chargingPile/payDeviceAnnualFee`, {
    params,
  });
}

function refreshCache(ids) {
  return request.post(`/device/common/device/refreshCacheByIds?ids=${ids}`);
}

export { payDeviceAnnualFee, refreshCache };
